import { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Redirect } from './pages/authentication/Redirect';
import { SignIn } from './pages/authentication/SignIn';
import { SignOut } from './pages/authentication/SignOut';
import { SignOutRedirect } from './pages/authentication/SignOutRedirect';
import { CategoryPage } from './pages/documents/CategoryPage';
import { Documents } from './pages/documents/Documents';
import { MyDocuments } from './pages/documents/MyDocuments';
import { MyDocumentsSectionPage } from './pages/documents/MyDocumentsSectionPage';
import { SearchPage } from './pages/documents/SearchPage';
import { SearchResultsPage } from './pages/documents/SearchResultsPage';
import { SectionPage } from './pages/documents/SectionPage';
import { UploadFiles } from './pages/documents/upload/UploadFiles';
import { HomePage } from './pages/home/HomePage';
import { Loading } from './pages/site/Loading';
import { NotFound } from './pages/site/NotFound';
import { Authenticated, AuthenticationProvider } from './services/authentication/AuthenticationProvider';
import { BackstageProvider } from './services/backstage/BackstageProvider';
import { GraphProvider } from './services/graph/GraphProvider';
import { QueryProvider } from './services/graph/QueryProvider';
import { AppInsightsProvider } from './services/insights/AppInsightsProvider';
import { CustomerInformationManager } from './services/insights/CustomerInformationManager';
import { DebugProvider } from './services/insights/DebugProvider';
import { OneDriveUploadProvider } from './services/upload/OneDriveUploadProvider';
import { CriticalErrorBoundary } from './utils/ErrorBoundary';
import { APIProvider } from './services/api/APIProvider';

function App() {
  return (
    <Suspense>
      <BackstageProvider>
        <DebugProvider>
          <AppInsightsProvider>
            <AuthenticationProvider>
              <BrowserRouter>
                <CriticalErrorBoundary>
                  <QueryProvider>
                    <GraphProvider>
                      <APIProvider>
                        <OneDriveUploadProvider>
                          <Suspense fallback={<Loading></Loading>}>
                            <Routes>
                              <Route element={<Authenticated />}>
                                <Route element={<CustomerInformationManager />}>
                                  <Route path="/" element={<HomePage />} />
                                  <Route path="/documents">
                                    <Route path="categories/:categoryId">
                                      <Route path="" element={<CategoryPage />} />
                                      <Route path="sections/:sectionId" element={<SectionPage />} />
                                    </Route>
                                    <Route path="myDocuments">
                                      <Route path="" element={<MyDocuments />} />
                                      <Route path="sections/:sectionId" element={<MyDocumentsSectionPage />} />
                                      <Route
                                        path="sections/:sectionId/subsections/:subSectionId"
                                        element={<MyDocumentsSectionPage />}
                                      />
                                    </Route>
                                    <Route path="search">
                                      <Route path="" element={<SearchPage />} />
                                      <Route path=":searchTerm" element={<SearchResultsPage />} />
                                    </Route>
                                    <Route path="upload/:searchTerm?" element={<UploadFiles />} />
                                    <Route path="" element={<Documents />} />
                                  </Route>
                                </Route>
                              </Route>
                              <Route path="auth">
                                <Route path="signout" element={<SignOut />} />
                                <Route path="redirect" element={<Redirect />} />
                                <Route path="signin" element={<SignIn />} />
                                <Route path="signout/redirect" element={<SignOutRedirect />} />
                              </Route>
                              <Route path="*" element={<NotFound />} />
                            </Routes>
                          </Suspense>
                        </OneDriveUploadProvider>
                      </APIProvider>
                    </GraphProvider>
                  </QueryProvider>
                </CriticalErrorBoundary>
              </BrowserRouter>
            </AuthenticationProvider>
          </AppInsightsProvider>
        </DebugProvider>
      </BackstageProvider>
    </Suspense>
  );
}

export default App;
